import ServiceBase from '@shared/api/base/ServiceBase';
import { serverTimestamp } from 'firebase/firestore';

class VideoComprehensionServices extends ServiceBase {
    constructor() {
        super('VideoComprehensionServices');
    }

    /**
     * Records that a user has passed a specific video comprehension check.
     */
    async recordPass(userId: string, pvcId: string) {
        const path = `users/${userId}/videoComprehension`;
        return this.setDoc(path, pvcId, {
            passed: true,
            completedAt: serverTimestamp()
        });
    }

    /**
     * Retrieves all passed video comprehension checks for a specific user.
     */
    async getPassedComprehensions(userId: string) {
        const path = `users/${userId}/videoComprehension`;
        try {
            return await this.getCollection(path);
        } catch (error: any) {
            // If the collection doesn't exist yet, return empty array
            if (error.code === 'NOT_FOUND') {
                return [];
            }
            throw error;
        }
    }
}

export const videoComprehensionServices = new VideoComprehensionServices();
export default videoComprehensionServices;
